import React, { useEffect } from "react";
import "./Skeleton.css";

const Skeleton = () => {
  const path = window.location.pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  return (
    <div className="skelBanner">
      <div></div>
      <div>
        <div></div>
        <div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
